// extracted by mini-css-extract-plugin
module.exports = {"burgerWrap":"PanelButtons_burgerWrap__1zdgk","btnWrapper":"PanelButtons_btnWrapper__1jazD"};